import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import FilterWordsProfileActions from 'actions/FilterWordsProfileActions';
import {Record, List} from 'immutable';

/** Stores filter word profiles used in the department admin page's dropdown. */
@immutableStore
class FilterWordsProfileStore {
  constructor() {
    this.state = Record({
      filterWordsProfiles: List(),
      wasError: false,
      isLoading: false,
    })();
    this.bindActions(FilterWordsProfileActions);
  }

  fetchAll() {
    this.setState({
      filterWordsProfiles: List(),
      isLoading: true,
      wasError: false,
    });
  }

  fetchAllSuccess(filterWordsProfiles) {
    this.setState({isLoading: false, filterWordsProfiles});
  }

  fetchAllError() {
    this.setState({isLoading: false, wasError: true});
  }
}

export default alt.createStore(FilterWordsProfileStore);
